import { render, staticRenderFns } from "./scan.vue?vue&type=template&id=823f0560&scoped=true&"
import script from "./scan.vue?vue&type=script&lang=js&"
export * from "./scan.vue?vue&type=script&lang=js&"
import style0 from "./scan.vue?vue&type=style&index=0&id=823f0560&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823f0560",
  null
  
)

export default component.exports